import {ReactComponent as Icon} from '@image/icon_logout.svg';

const iconLogout = () => {
    return   <Icon />;
};

export default iconLogout;